"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationMySitePiggyBank = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 126 88",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(-1166.000000, -1044.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(1166.000000, 1044.000000)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M73.2089619,14.0146489 C65.1313683,13.7326841 57.4373603,11.1039382 50.0912551,8.22833606 C42.7451496,5.35273387 35.4670638,2.16554412 27.5834931,0.641617593 C22.5121381,-0.338127826 16.71264,-0.476367381 12.6270101,2.26318952 C8.69414527,4.89632391 7.42407637,9.45384067 6.74165127,13.6734385 C6.22760235,16.8551426 5.92541739,20.1959319 7.33264034,23.1713737 C8.31055992,25.2372871 10.0467296,26.9729615 11.2476639,28.9511037 C15.4236148,35.835653 12.474245,44.3253171 7.94481578,51.0474898 C5.82617584,54.2006682 3.3585178,57.2090241 1.72047461,60.5651735 C0.0824313733,63.9213228 -0.675818698,67.767893 0.757050971,71.1920649 C2.17876986,74.5866139 5.56413353,77.1352687 9.23161076,78.9279944 C16.6814179,82.5704972 25.4163961,85 34.0208133,85 C53.2016269,85 72.1636364,85 91.0211489,85 C98.0596974,85 105.114565,83.9550869 112.032482,82.8590448 C115.872796,82.2501322 119.837997,81.2846495 122.625681,78.9521316 C126.16604,75.9898553 127.043603,70.9792199 124.670727,67.2675979 C120.695489,61.043526 109.693057,59.4987541 106.912064,52.8149813 C105.381068,49.1373702 106.953321,45.040652 109.177893,41.6241601 C113.950409,34.3073379 121.949947,27.8879757 122.371445,19.5233854 C122.661364,13.7787639 118.815474,8.02536527 112.869902,5.30775116 C106.63664,2.4551889 97.9948193,2.81724488 93.3962556,7.53274969 C88.6616529,12.3963684 80.3409732,14.2647966 73.2089619,14.0146489 Z",
            fill: "#E7EEFC",
            fillRule: "nonzero",
            className: "fill-primary",
            opacity: "0.1"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(22.909091, 4.594595)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              className: "fill-primary",
              fill: "#1657E2",
              transform: "translate(49.254545, 74.662162) scale(-1, 1) translate(-49.254545, -74.662162) ",
              points: "54.9818182 68.9189189 54.9818182 80.4054054 50.4 80.4054054 43.5272727 68.9189189"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              className: "fill-primary",
              fill: "#1657E2",
              transform: "translate(25.772727, 74.662162) scale(-1, 1) translate(-25.772727, -74.662162) ",
              points: "31.5 68.9189189 31.5 80.4054054 26.9181818 80.4054054 20.0454545 68.9189189"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M11.4545455,17.2297297 C20.3111845,17.2297297 27.4909091,24.4094543 27.4909091,33.2660934 L27.4909091,35.6081081 L27.4909091,35.6081081 L13.7518428,35.6081081 C12.4830805,35.6081081 11.4545455,34.5795731 11.4545455,33.3108108 L11.4545455,17.2297297 L11.4545455,17.2297297 Z",
              className: "fill-primary",
              fill: "#1657E2"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              transform: "translate(10.595455, 64.037162)"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M25.7727273,17.2297297 C31.2303675,17.2297297 36.0512374,19.9560677 38.947703,24.1211099 L50.3361179,24.1216216 C63.0237406,24.1216216 73.3090909,34.406972 73.3090909,47.0945946 L73.3090909,49.3918919 C73.3090909,62.0795145 63.0237406,72.3648649 50.3361179,72.3648649 L28.4138821,72.3648649 C15.7262594,72.3648649 5.44090909,62.0795145 5.44090909,49.3918919 L5.44090909,47.0945946 C5.44090909,35.3002771 14.3289124,25.5818641 25.7724438,24.2718308 L25.7727273,17.2297297 Z",
              className: "fill-primary-opa50",
              fill: "#88A9F0"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
              fill: "#091E43",
              cx: "21.7636364",
              cy: "41.3513514",
              rx: "2.57727273",
              ry: "2.58445946"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
              fill: "#091E43",
              cx: "6.01363636",
              cy: "41.3513514",
              rx: "2.57727273",
              ry: "2.58445946"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M50.3361179,72.3648649 L28.4138821,72.3648649 C21.3004172,72.3648649 14.9420864,69.1317512 10.7281982,64.0548323 C14.3314285,66.4044549 18.6358809,67.7702703 23.2593366,67.7702703 L23.2593366,67.7702703 L55.4906634,67.7702703 C60.1141698,67.7702703 64.4186659,66.404425 68.0226738,64.0542124 C63.8079136,69.1317512 57.4495828,72.3648649 50.3361179,72.3648649 Z",
              className: "fill-primary",
              fill: "#1657E2",
              opacity: "0.244073"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
              className: "fill-primary",
              fill: "#1657E2",
              opacity: "0.242629278",
              cx: "10.5954545",
              cy: "52.2635135",
              rx: "8.01818182",
              ry: "10.3378378"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
              className: "fill-primary",
              fill: "#1657E2",
              cx: "8.01818182",
              cy: "52.2635135",
              rx: "8.01818182",
              ry: "10.3378378"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              fill: "#091E43",
              x: "3.43636364",
              y: "49.6790541",
              width: "2.29090909",
              height: "4.88175676",
              rx: "1.14545455"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              fill: "#091E43",
              x: "8.01818182",
              y: "49.6790541",
              width: "2.29090909",
              height: "4.88175676",
              rx: "1.14545455"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              transform: "translate(25.772727, 23.547297)",
              className: "fill-primary",
              fill: "#1657E2",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M0,0 C5.85170796,-1.07494131e-15 10.5954545,4.74374658 10.5954545,10.5954545 L10.5954545,12.0608108 L10.5954545,12.0608108 L2.2972973,12.0608108 C1.02853503,12.0608108 5.99467774e-16,11.0322758 0,9.76351351 L0,0 L0,0 Z"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              className: "fill-primary-opa50",
              fill: "#88A9F0",
              points: "35.5090909 64.8986486 35.5090909 80.4054054 30.9272727 80.4054054 20.0454545 64.8986486"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              className: "fill-primary-opa50",
              fill: "#88A9F0",
              transform: "translate(61.281818, 71.790541) scale(-1, 1) translate(-61.281818, -71.790541) ",
              points: "68.7272727 67.7702703 68.7272727 80.4054054 64.1454545 80.4054054 53.8363636 63.1756757"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              transform: "translate(53.836364, 62.027027)",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#FDD33F",
                  x: "0",
                  y: "0",
                  width: "12.0272732",
                  height: "18.3783791"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#F7B523",
                  x: "0",
                  y: "0",
                  width: "3.43636377",
                  height: "18.3783791"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#FFE168",
                  x: "8.41909124",
                  y: "0",
                  width: "1.71818189",
                  height: "18.3783791"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#F7B523",
                  x: "3.26454558",
                  y: "5.01228521",
                  width: "1.71818189",
                  height: "3.34152347"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#F7B523",
                  x: "3.26454558",
                  y: "15.0368556",
                  width: "1.71818189",
                  height: "3.34152347"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#F7B523",
                  x: "0",
                  y: "3.34152347",
                  width: "12.0272732",
                  height: "2.01013514"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#F7B523",
                  x: "0",
                  y: "8.35380869",
                  width: "12.0272732",
                  height: "1.67076174"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#F7B523",
                  x: "0",
                  y: "13.3660939",
                  width: "12.0272732",
                  height: "1.67076174"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                transform: "translate(9.736364, 5.168919)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#FDD33F",
                  x: "0",
                  y: "0",
                  width: "12.0272732",
                  height: "13.20946"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#F7B523",
                  x: "-2.54342002e-16",
                  y: "5.24896748e-07",
                  width: "3.43636377",
                  height: "13.2094595"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#FFE168",
                  x: "8.41909124",
                  y: "0",
                  width: "1.71818189",
                  height: "13.20946"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#F7B523",
                  x: "3.26454558",
                  y: "4.95354749",
                  width: "1.71818189",
                  height: "3.302365"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#F7B523",
                  x: "0",
                  y: "3.302365",
                  width: "12.0272732",
                  height: "1.6511825"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                  fill: "#F7B523",
                  x: "0",
                  y: "8.25591249",
                  width: "12.0272732",
                  height: "1.6511825"
                })]
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M41.2363636,29.8648649 L57.2727273,29.8648649 C57.2727273,31.1336271 56.2441922,32.1621622 54.97543,32.1621622 L43.5336609,32.1621622 C42.2648987,32.1621622 41.2363636,31.1336271 41.2363636,29.8648649 L41.2363636,29.8648649 L41.2363636,29.8648649 Z",
              fill: "#091E43"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              transform: "translate(42.381818, 16.655405)",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
                fill: "#FDD33F",
                cx: "6.87272727",
                cy: "6.89189189",
                rx: "6.87272727",
                ry: "6.89189189"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
                fill: "#F7B523",
                cx: "6.87272727",
                cy: "6.89189189",
                rx: "5.44090909",
                ry: "5.45608108"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
                fill: "#FDD33F",
                cx: "7.01590909",
                cy: "7.03547297",
                rx: "3.86590909",
                ry: "3.87668919"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              transform: "translate(42.381818, 0.000000)",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
                fill: "#FDD33F",
                cx: "6.87272727",
                cy: "6.89189189",
                rx: "6.87272727",
                ry: "6.89189189"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
                fill: "#F7B523",
                cx: "6.87272727",
                cy: "6.89189189",
                rx: "5.44090909",
                ry: "5.45608108"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
                fill: "#FDD33F",
                cx: "7.01590909",
                cy: "7.03547297",
                rx: "3.86590909",
                ry: "3.87668919"
              })]
            })]
          })]
        })
      })
    })
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationMySitePiggyBank')(IllustrationMySitePiggyBank);